import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.019 24.07c-.003-4.314-.25-8.148-.741-11.505A3 3 0 0 0 35.31 10h-1.3a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h1.323a3 3 0 0 0 2.968-2.564c.482-3.28.72-7.069.718-11.366Zm-9.663-3.037-15.232-9.52a3.002 3.002 0 0 0-4.571 2.21c-.366 3.268-.55 6.715-.553 10.341-.002 3.606.175 7.01.532 10.212a3 3 0 0 0 4.57 2.213l15.252-9.52a3.499 3.499 0 0 0 .002-5.936Z",
    fill: "currentColor"
  }));
};

var SvgSkipNext = styled(SvgComponent).withConfig({
  displayName: "SkipNext__SvgSkipNext",
  componentId: "sc-x1dqrn-0"
})(["", " ", ""], size, color);
export default SvgSkipNext;